/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (horizontal scrollable product slider with
 *              left/right scroll buttons)
 *   extends:   Component (@glimmer/component)
 *   template:  slide-prodotti.hbs
 *   args:      -
 *   uses:      @ember/object/internals guidFor
 *   siblings:  -
 *   tests:     storefront-components-test.js, populated-storefront-test.js
 *
 * `sideScroll` smooth-scrolls the DOM element identified by this instance's
 * guidFor-derived slideId, left or right by a fixed pixel delta.
 */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';

export default class SlideProdottiComponent extends Component {
  slideId = 'slide-' + guidFor(this);

  @action
  sideScroll(side = 'right') {
    const delta = side === 'right' ? 900 : -900;
    const el = document.getElementById(this.slideId);

    if (el) {
      el.scrollBy({ left: delta, behavior: 'smooth' });
    }
  }
}
